import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IconButton, TextField } from '@mui/material';
import { CheckForURL } from '../../helper/commonHelper';
import Modal from '../common/Modal';
import BackArrowIcon from '../../svg/BackArrowIcon';
import { createLinkResource, fetchLinkTitle, updateResource } from '../../service/resource.service';

export default function ResourceYoutubeOrLinkModal({ editObj, title, onCancel, onClose, open }) {
  const [url, setUrl] = useState('');
  const [name, setName] = useState('');
  const [urlError, setUrlError] = useState(false);
  const classData = useSelector((state) => state.classes.selectedClass);
  const { id: classId, orgId } = classData;
  const [isUrlTitle, setUrlTitle] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    if (editObj) {
      setName(editObj.name);
      setUrl(editObj.file);
      setUrlTitle(editObj.name);
    }
  }, [editObj]);

  const uploadUrl = async () => {
    const isUrlValid = CheckForURL(url);
    setUrlError(!isUrlValid);
    if (isUrlValid) {
      setIsUploading(true);
      const urlObj = {
        orgId: orgId._id,
        // eslint-disable-next-line
        type: url.includes('youtube') ? 'youtube' : url.includes('youtu') ? 'youtube' : 'link',
        file: url
      };
      if (name) urlObj.name = name;
      const res = await createLinkResource(classId, urlObj);
      if (res) {
        setUrl('');
        setIsUploading(false);
        setName('');
        onCancel();
        onClose();
      }
    }
  };

  const fetchUrlTitle = async (e) => {
    if (e.target.value) {
      const urlData = await fetchLinkTitle(e.target.value);
      if (urlData) {
        setUrlTitle(urlData.ogTitle);
        setName(urlData.ogTitle);
      } else {
        setUrlTitle('');
      }
    } else {
      setUrlTitle(null);
      setName('');
    }
  };

  const updateUrl = async () => {
    const isUrlValid = CheckForURL(url);
    setUrlError(!isUrlValid);
    if (isUrlValid) {
      setIsUploading(true);
      const urlObj = {
        // eslint-disable-next-line
        type: url.includes('youtube') ? 'youtube' : url.includes('youtu') ? 'youtube' : 'link',
        file: url
      };
      if (name) urlObj.name = name;
      const res = await updateResource(editObj.id, urlObj);
      if (res) {
        setIsUploading(false);
        setUrl('');
        setName('');
        onCancel();
      }
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <>
          {!editObj && (
            <IconButton style={{ marginRight: 10 }} onClick={() => onCancel()}>
              <BackArrowIcon />
            </IconButton>
          )}{' '}
          {title}
        </>
      }
      cancelText="Cancel"
      onCancel={() => onCancel()}
      actionText={editObj ? 'Update' : 'Save'}
      onAction={editObj ? () => updateUrl() : () => uploadUrl()}
      isCancelDisabled={isUploading}
      isBtnLoading={isUploading}
      isActionDisabled={!isUrlTitle}
    >
      <TextField
        margin="dense"
        value={url}
        InputLabelProps={{
          shrink: url.length !== 0
        }}
        label="URL"
        placeholder="https://"
        name="url"
        type="text"
        fullWidth
        error={urlError}
        onBlur={fetchUrlTitle}
        helperText={urlError ? 'Please enter valid URL' : ''}
        onChange={(e) => {
          setUrl(e.target.value);
        }}
      />
      <TextField
        margin="dense"
        value={name}
        label="Name(optional)"
        name="name"
        type="text"
        InputLabelProps={{
          shrink: isUrlTitle
        }}
        fullWidth
        disabled={!isUrlTitle}
        onChange={(e) => {
          setName(e.target.value);
        }}
      />
    </Modal>
  );
}

ResourceYoutubeOrLinkModal.propTypes = {
  title: PropTypes.string,
  onCancel: PropTypes.func,
  editObj: PropTypes.shape({
    name: PropTypes.string,
    file: PropTypes.string,
    id: PropTypes.string
  }),
  onClose: PropTypes.func,
  open: PropTypes.bool
};
